import { render } from "./TrailerPlayerDialog.vue?vue&type=template&id=7a59c8d0"
import script from "./TrailerPlayerDialog.vue?vue&type=script&lang=js"
export * from "./TrailerPlayerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QVideo from 'quasar/src/components/video/QVideo.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBar,QSpace,QBtn,QResizeObserver,QVideo});qInstall(script, 'directives', {ClosePopup});
